import { useAuth0 } from "@auth0/auth0-react";
import DefaultUserOPNG from "assets/icons/easytemplelogo.png";
import { ReactComponent as PencilSVG } from "assets/icons/pencil.svg";
import BottomArrowSvg from "assets/icons/svg/BottomArrowSvg";
import countriesJson from "assets/json/countries.json";
import Button from "components/button/Button";
import MyButton from "components/MyButton";
import MyModal from "components/MyModal";
import { PhonePicker } from "components/PhonePicker";
import { FieldArray, FormikProvider } from "formik";
import { useDisableEnterKey } from "hook";
import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import "react-image-crop/dist/ReactCrop.css";
import ImageUploader from "react-images-upload";
import { useDispatch } from "react-redux";
import Select, { components } from "react-select";
import { colors } from "theme";
import { getOrganizationInfoFromLocalStorage } from "utils/functions";
import { HintField, InputField, Text } from "../../components";
import { HeaderLogo, HeaderLogoInBase } from "../../store/redux/actions";
import "./index.scss";


const selectControlStyles = {
  backgroundColor: "#F3F6F9",
  border: "none",
  color: "#b5b5c3",
  transition:
    "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  paddingTop: "6px",
  paddingBottom: "6px",
  cursor: "pointer",

};
const selectStyles = {
  control: (styles) => ({
    ...styles,
    ...selectControlStyles,
  }),
  menuList: (styles) => ({
    ...styles,
    maxHeight: "200px",
  }),
};

const DropdownIndicator = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <BottomArrowSvg label="Emoji" />
    </components.DropdownIndicator>
  );
};



const styles = {
  circleButtonBody: {
    background: "#FFFFFF",
    borderRadius: "50%",
    width: 20,
    height: 20,
    right: 0,
    top: 3,
    cursor: "pointer",
  },
  textIconButton: {
    color: colors.primaryColor,
    fontSize: 17,
    fontWeight: "bolder",
  },
};

const orgDetails = getOrganizationInfoFromLocalStorage();

const PersonalInfoEdit = ({ userInfo, refresh, setRefresh, data,formik,setPictures }) => {
  const orgDetails = JSON.parse(localStorage.getItem("organization"));
  const [type, setType] = useState(false);
  const [open, setOpen] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [image, setImage] = useState(DefaultUserOPNG);

  const [imageToCrop, setImageToCrop] = useState(undefined);
  const [croppedImage, setCroppedImage] = useState(null);
  const [companyLogo, setCompanyLogo] = useState("");

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(HeaderLogo(userInfo?.user?.permissions?.organization?.logoImg));
    toDataUrl(
      userInfo?.user?.permissions?.organization?.logoImg,
      function (myBase64) {
        dispatch(HeaderLogoInBase(myBase64));
        return localStorage?.setItem("Base64", myBase64);
      }
    );
    setCompanyLogo(userInfo?.user?.permissions?.organization?.logoImg);
  }, [userInfo]);

  function toDataUrl(url, callback) {
    if (url !== null) {
      var xhr = new XMLHttpRequest();
      xhr.onload = function () {
        var reader = new FileReader();
        reader.onloadend = function () {
          callback(reader.result);
        };
        reader.readAsDataURL(xhr.response);
      };
      xhr.open("GET", url);
      xhr.responseType = "blob";
      xhr.send();
    }
  }
  
  const onUploadFile = async (pictureFiles) => {
    setPictures(pictureFiles[0]);
    let imageDataUrl = await readFile(pictureFiles[0]);
    setCroppedImage(imageDataUrl);
    setOpen(false);
  };

  function readFile(file) {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener("load", () => resolve(reader.result), false);
      reader.readAsDataURL(file);
    });
  }


  const handleOpen = () => {
    setCroppedImage(null);
    setImageToCrop(undefined);

    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Dynamic Tab name
  const documentTitle = (title) => {
    document.title = title;
  };
  const radioList = [
    { name: "Stripe", value: "Stripe" },
    { name: "Authorize", value: "Authorize" },
  ];


  useEffect(() => {
    documentTitle(orgDetails?.orgName);
  }, [orgDetails?.orgName]);



  const formatOptionLabel = ({ name, code }) => {
    return (
      <div className="dropdown-container" key={code}>
        <div className="icon-name-container d-flex align-items-center justify-content-start">
          <div className="name-container" style={{ marginInlineStart: 10 }}>
            <div>{name}</div>
          </div>
        </div>
      </div>
    );
  };

  useDisableEnterKey(true);


  return (
    <div className="profile-container">
      <div className="edit-profile-container">
        <div className="profile-header">
          <div>
            <div className="main-text">Organization Information </div>
            <div className="body-text">Update Organization Information </div>
          </div>
        </div>
        <hr />
        <div className="profile-body">
          <Row>
            <Col className="col-sm-4">
              <div className="form-name">Logo</div>
            </Col>
            <Col className="col-sm-6">
              <div className="row mb-5">
                <div className="position-relative">
                  <div
                    className={
                      image !== DefaultUserOPNG
                        ? "image-container h-80px"
                        : undefined
                    }
                  >
                    {/* {croppedImage ? (
                      <img src={croppedImage} alt="croppedImage"></img>
                    ) : ( */}
                    <img
                      alt=""
                      src={croppedImage !== null ? croppedImage : companyLogo}
                      style={{
                        objectFit: "fill",
                        maxWidth: "100%",
                        width: "100%",
                      }}
                      className={
                        // image !=zy= DefaultUserOPNG ?
                        "image"
                        // : undefined
                      }
                      name="logoImg"
                    />
                    {/* )} */}
                  </div>
                  <div
                    className="shadow text-center justify-content-center align-items-center position-absolute"
                    style={{
                      ...styles.circleButtonBody,
                      right: image !== DefaultUserOPNG ? -7 : 0,
                    }}
                    onClick={handleOpen}
                  >
                    <PencilSVG />
                  </div>
                </div>

                <div className="col-sm-12">
                  <Text style={{ color: "#B5B5C3", fontSize: 12 }}>
                    Reccomended file size: 260W X 100H, allowed file types: png,
                    jpg, jpeg.
                  </Text>
                </div>
                {formik.touched["logoImg"] && formik.errors["logoImg"] ? (
                  <HintField
                    error={formik.errors["logoImg"]}
                    className="col-sm-12"
                  />
                ) : null}
              </div>
            </Col>
          </Row>
          <Row className="d-flex align-items-center mt-5">
            <Col className="col-sm-4">
              <div className="form-name" style={{ marginTop: 0 }}>Organization Name</div>
            </Col>
            <Col className="col-sm-6">
              <InputField
                mandatory={false}
                {...{
                  formik,
                  // title: "First Name",
                  name: "organizationName",
                  placeholder: "Organization",
                  checkValidation: true,
                  value: formik.values?.organizationName,
                }}
              />
            </Col>
          </Row>
          <Row className="d-flex align-items-center mt-5">
            <Col className="col-sm-4">
              <div className="form-name" style={{ marginTop: 0 }}>Shul Website Link</div>
            </Col>
            <Col className="col-sm-6">
              <InputField
                mandatory={false}
                {...{
                  formik,
                  // title: "First Name",
                  name: "shulwebsitelink",
                  placeholder: "Link",
                  checkValidation: true,
                  value: formik.values?.shulwebsitelink,
                }}
              />
            </Col>
          </Row>
          <Row className="country-field-height mt-4 d-flex align-items-center ">
            <Col className="col-sm-4">
              <div className="form-name" style={{margin: 0}}>Country</div>
            </Col>
            <Col className="col-sm-6">
              <Select
                  menuPosition={'fixed'} 
                  classNamePrefix="react-select"
                  formatOptionLabel={formatOptionLabel}
                  placeholder="Select a Country"
                  options={countriesJson || []}
                  styles={selectStyles}
                  onChange={(value) => {
                    formik.setFieldValue("country", value);
                  }}
                  value={formik.values?.country}
                  components={{ DropdownIndicator }}
              />
            </Col>
          </Row>
          <Row>
            <Col className="col-sm-4"></Col>
            <Col className="col-sm-6 ml-0">
              <div className="contact-info ml-0 mb-3">Contact info</div>
            </Col>
          </Row>
          <FormikProvider value={formik}>
            <FieldArray
              name="phoneNumber"
              render={({ insert, remove, pop, push }) =>
                formik?.values.phoneNumber?.length &&
                formik?.values.phoneNumber?.map((data, index) => (
                  <div key={index}>
                    <Row className="d-flex align-items-center mt-5">
                      <Col className="col-sm-4">
                        <div className="form-name" style={{ marginTop: 0 }}>Phone Number</div>
                      </Col>
                      <Col className="col-sm-6">
                        <InputField
                          mandatory={false}
                          {...{
                            formik,
                            name: `phoneNumber[${index}]phone_number`,
                            placeholder: "Phone",
                            checkValidation: false,
                            value: formik.values.phoneNumber[index].phone_number,
                          }}
                        />
                        <HintField
                          className="formik-error"
                          error={
                            formik?.errors?.phoneNumber &&
                            formik?.errors?.phoneNumber[index]?.phone_number
                          }
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex align-items-center mt-5">
                      <Col className="col-sm-4">
                        <div className="form-name" style={{ marginTop: 0 }}>Contact Name</div>
                      </Col>
                      <Col className="col-sm-6">
                        <InputField
                          mandatory={false}
                          {...{
                            formik,
                            name: `phoneNumber[${index}]contact_name`,
                            placeholder: "David",
                            checkValidation: true,
                            value:
                              formik.values?.phoneNumber?.[index]?.contact_name,
                          }}
                        />
                        <HintField
                          className="formik-error"
                          error={
                            formik?.errors?.phoneNumber &&
                            formik?.errors?.phoneNumber[index]?.contact_name
                          }
                        />
                        {/* <div className="contact-info-change">
                          <div>
                            <div className="row ml-1">
                              <label className="checkbox checkbox-lg checkbox-single mr-2">
                                <input
                                  type="checkbox"
                                  name={`phoneNumber[${index}]preferredNumber`}
                                  onChange={(val) => {
                                    formik.setFieldValue &&
                                      formik.setFieldValue(
                                        `phoneNumber[${index}]preferredNumber`,
                                        val.target.checked
                                      );
                                  }}
                                />
                                <span />
                              </label>
                              <label className="text mt-2">
                                Set as preferred number
                              </label>
                            </div>
                            <div className="row ml-1">
                              <label className="checkbox checkbox-lg checkbox-single mr-2">
                                <input
                                  type="checkbox"
                                  name={`phoneNumber[${index}]emergencyNumber`}
                                  onChange={(val) => {
                                    formik.setFieldValue &&
                                      formik.setFieldValue(
                                        `phoneNumber[${index}]emergencyNumber`,
                                        val.target.checked
                                      );
                                  }}
                                />
                                <span />
                              </label>
                              <label className="mt-2">
                                Set as emergency contact
                              </label>
                            </div>
                          </div>
                        </div> */}
                        {/* <div
                          className="add-another-number d-flex justify-content-end"
                          onClick={() => push()}
                        >
                          Add Another phone Number
                        </div> */}
                      </Col>
                    </Row>
                  </div>
                ))
              }
            />
          </FormikProvider>
          <Row className="d-flex align-items-center mt-5">
            <Col className="col-sm-4">
              <div className="form-name" style={{ marginTop: 0 }}>Email Address</div>
            </Col>
            <Col className="col-sm-6">
              <InputField
                mandatory={false}
                type={"email"}
                {...{
                  formik,
                  name: "emailAddress",
                  placeholder: "asd@gmail.com",
                  checkValidation: true,
                  value: formik.values?.emailAddress,
                }}
                copy={true}
              />
            </Col>
          </Row>
          <Row className="d-flex align-items-center mt-5">
            <Col className="col-sm-4">
              <div className="form-name" style={{ marginTop: 0 }}>Address</div>
            </Col>
            <Col className="col-sm-6">
              <InputField
                mandatory={false}
                {...{
                  formik,
                  name: "address",
                  placeholder: "",
                  checkValidation: true,
                  value: formik.values?.address,
                }}
              />
            </Col>
          </Row>
          <Row>
            <Col className="col-sm-4"></Col>
            <Col className="col-sm-6 ml-0">
              <div className="contact-info ml-0">Billing contact</div>
            </Col>
          </Row>
          <div>
            <Row className="d-flex align-items-center mt-5">
              <Col className="col-sm-4">
                <div className="form-name" style={{ marginTop: 0 }}>Name</div>
              </Col>
              <Col className="col-sm-6">
                <InputField
                  mandatory={false}
                  {...{
                    formik,
                    // title: "First Name",
                    name: "name",
                    placeholder: "Name",
                    checkValidation: true,
                    value: formik.values?.name,
                  }}
                />
              </Col>
            </Row>
            <Row className="d-flex align-items-center mt-5">
              <Col className="col-sm-4">
                <div className="form-name" style={{ marginTop: 0 }}>Email Address</div>
              </Col>
              <Col className="col-sm-6">
                <InputField
                  mandatory={false}
                  {...{
                    formik,
                    name: "billingEmailAddress",
                    placeholder: "asd@gmail.com",
                    checkValidation: true,
                    value: formik.values?.billingEmailAddress,
                  }}
                  copy={true}
                />
              </Col>
            </Row>
          </div>
        </div>
      </div>
      <div className="personal-info-image">
        <MyModal open={open} onClose={handleClose}>
          <div className="modal-body text-center">
            <Text style={{ fontWeight: "bolder" }}>Add/Change Logo</Text>
          </div>
          <div className="text-center">
            {/* <input type="file" accept="image/*" onChange={onUploadFile} /> */}
            <div className="mt-2">
              {/* <ImageCropper
                setWebsiteLogoImg={setWebsiteLogoImg}
                imageToCrop={imageToCrop}
                onImageCropped={(croppedImage) => setCroppedImage(croppedImage)}
              /> */}
              <ImageUploader
                withIcon={false}
                withPreview={true}
                buttonText="Choose images"
                onChange={onUploadFile}
                accept=".png,.jpg,.jpeg"
                imgExtension={[".jpg", ".png", ".jpeg"]}
                maxFileSize={5242880}
              />
            </div>
            {/* {croppedImage && (
              <div>
                <h2>Cropped Image</h2>
                <img alt="Cropped Img" src={croppedImage} />
              </div>
            )} */}
          </div>
        </MyModal>
      </div>
      <div className="page-footer d-flex justify-content-end mt-10">
        <Button 
          className="cancel-button organization-button" 
          onClick={() => {
            formik.setValues(formik.initialValues);
          }}
          variant="primary-outline"
          size="md"
          style={{ minWidth: 80 }}
        >

          Cancel
        </Button>
        <Button
          className="save-button organization-button"
          onClick={() => {
            formik.handleSubmit();
          }}
          variant="primary"
          size="md"
          style={{ minWidth: 80 }}
        >
        Save
        </Button>
      </div>
    </div>
  );
};

export default PersonalInfoEdit;
